import communicationReducer from './communication.reducer';

export { default as communicationActions } from './communication.actions';
export { communicationActionTypes } from './communication.actions';
export { default as communicationSelectors } from './communication.selectors';

export default communicationReducer;
